import { isPlatformBrowser } from '@angular/common';
import { Component, inject, Input, PLATFORM_ID } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { ProductListOutlets } from '@spartacus/storefront';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-kb-software-list-item',
  templateUrl: './kb-software-list-item.component.html',
  styleUrls: ['./kb-software-list-item.component.scss'],
  standalone: false
})
export class KbSoftwareListItemComponent {
  @Input() product: any;
  @Input() searchQuery: any;
  readonly ProductListOutlets = ProductListOutlets;
  isLoggedIn: boolean = false;
  distributerType: string;
  platformId = inject(PLATFORM_ID);
  private destroy$ = new Subject<void>();
  constructor(public authService: AuthService) {
    this.authService
      .isUserLoggedIn().pipe(takeUntil(this.destroy$))
      .subscribe((isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;
      })
    if (isPlatformBrowser(this.platformId)) {
      this.distributerType = document.cookie.split(";")[1]?.split("=")[1]?.split("_")[2];
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
